<template>
    <kgr-form-scaffold
        :pending="pending"
        :with-delete-button="true"
        edit-mode
        @primaryBtnClicked="addLocation"
        @backBtnClicked="redirectToOverview"
        @deleteBtnClicked="deleteLocation"
    >
        <kgr-location-basic-data-provider
            :location-id="locationId"
            :callback="onLocationLoaded"
        >
            <kgr-location-create-form
                :location="location"
                :error="error"
                @enter="addLocation"
            />
        </kgr-location-basic-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import Location from '../../js/dto/resource/Location';
import LocationBasicDataForm from '../../components/resource/LocationBasicDataForm';
import LocationBasicDataProvider from '../../components/data-provider/LocationDataProvider';
import LocationRepository from '../../js/repository/LocationRepository';

export default {
    components: {
        'kgr-location-basic-data-provider': LocationBasicDataProvider,
        'kgr-location-create-form': LocationBasicDataForm,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        locationId: {
            type: String,
            required: true,
        },
        overviewUrl: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            location: new Location(),
            error: new Error(),
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onLocationLoaded(loadedLocation) {
            this.location = loadedLocation;
        },
        addLocation() {
            if (this.pending) {
                return;
            }

            this.pending = true;
            LocationRepository.update(this.location)
                .then(() => {
                    this.$notify.success('Ort aktualisiert', {}, { saveInSession: true });
                    window.location = `/backend/resources/locations/${this.location.id}/edit`;
                })
                .catch((error) => {
                    this.handleError(error);
                    this.pending = false;
                });
        },
        deleteLocation() {
            if (this.location.isDeletable) {
                showConfirm(this.$t('confirm'), this.$t('Soll der Ort wirklich gelöscht werden?', {}), () => {
                    this.pendingRemove = true;
                    LocationRepository.delete(this.location)
                        .then(() => {
                            this.$notify.success('Der Ort wurde gelöscht');
                            this.pendingRemove = false;
                            this.redirectToOverview();
                        })
                        .catch(() => {
                            this.$notify.error('Der Ort konnte nicht gelöscht werden');
                            this.pending = false;
                        },
                        );
                }, 'Ok');
            } else {
                showConfirm(this.$t('confirm'), this.$t('location.archive.confirm', {}), () => {
                    this.pendingRemove = true;
                    LocationRepository.archive(this.location)
                        .then(() => {
                            this.$notify.success('Der Ort wurde archiviert');
                            this.pendingRemove = false;
                            this.redirectToOverview();
                        })
                        .catch(() => {
                            this.$notify.error('Der Ort konnte nicht archiviert werden');
                            this.pending = false;
                        },
                        );
                }, 'Ok');
            }
        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
